import {EvaluationPoint, EvaluationPointRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";

export const EvaluationPointListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<EvaluationPoint> = {
		title: "Preguntas de evaluación",
		onClick: "/app/admin/employee/evaluationpoint",
		headers: [
			{title: "Nombre"},
			{title: "Posición", align: "right", width: 120},
		],
		decorator: (bean: EvaluationPoint) => (
			< >
				<TableCell>
					{bean.label}
				</TableCell>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.position}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(EvaluationPointRestControllerApiFactory);
			return ctrl.pageEvaluationPoint(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};